import React from 'react';
import { Table } from 'reactstrap';
import { Plaintext } from '../../../Shared/Forms';
import { getTableListValues } from '../FormUtils';
import { withTranslation } from 'react-i18next';
import { LANGUAGE_KEYS } from '../../../Shared/Constants/LanguageKeys';
import { getLangKey } from '../../../Content/DisplayComponents/DisplayUtils';

class SmallPreviewTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    maximumErrorMessage = maximumRows => {
        this.setState({
            showMaximumRows: maximumRows
        });
    };

    render() {
        const { values, section, inputSize, t } = this.props;
        const tableValueKeys = Object.keys(values.FormData.LicenceInformation);
        const tableValues = values.FormData.LicenceInformation;

        return (
            <Table className="griddle-table">
                <thead className="griddle-table-heading">
                    <tr>
                        {section.Table.Fields && section.Table.Fields.map((field, findex) => {
                            return (
                                <th key={findex} className="griddle-table-heading-cell">{t(getLangKey(LANGUAGE_KEYS.BLS_COMMONINFO_FORM_FIELD_KEY, field.Name))}</th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody className="griddle-table-body">
                    {
                        getTableListValues(tableValueKeys, section.Name) &&
                        getTableListValues(tableValueKeys, section.Name)[section.Name] &&
                        getTableListValues(tableValueKeys, section.Name)[section.Name].map((row, rindex) => {
                            return (
                                <tr key={rindex} className="griddle-row">
                                    {section.Table.Fields && section.Table.Fields.map((field, findex) => {
                                        return (
                                            <td key={findex + rindex} className="griddle-cell table-griddle-cell">
                                                {
                                                    field.InputType !== 'FileUpload' && <Plaintext
                                                        label={undefined}
                                                        className="modal-plaintext"
                                                        key={findex + rindex}
                                                        name={field.Name}
                                                        value={tableValues[`${section.Name}.${rindex}.${field.Name}`]}
                                                        inputSize={inputSize}
                                                        labelSize={null}
                                                    />
                                                }
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })
                    }
                </tbody>
            </Table>
        );
    }
}
export default withTranslation()(SmallPreviewTable);